import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {AdminRoutingModule} from './admin-routing.module';
import {UserListComponent} from './users/user-list/user-list.component';
import {EditUserComponent} from './users/edit-user/edit-user.component';
import {ClientListComponent} from './clients/components/client-list/client-list.component';
import {EditClientComponent} from './clients/components/edit-client/edit-client.component';
import {AdminViewComponent} from './admin-view/admin-view.component';
import {EditProductComponent} from './products/components/edit-product/edit-product.component';
import {ProductListComponent} from './products/components/product-list/product-list.component';
import {EditServiceComponent} from './service-products/components/edit-service/edit-service.component';
import {ServiceListComponent} from './service-products/components/service-list/service-list.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule,
    AdminRoutingModule,
    ClientListComponent,
    EditClientComponent,
    EditProductComponent,
    EditUserComponent,
    EditServiceComponent,
    AdminViewComponent,
    ProductListComponent,
    UserListComponent,
    ServiceListComponent,
  ],
})

export class AdminModule {}
